// NotFound.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const PageNotFound = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      alert("This batch URL does not exist or has been deleted.");
      navigate("/batches", { replace: true });
    }, 2000); 

    return () => clearTimeout(timer); 
  }, [navigate]);

  return (
    <div style={{ textAlign: "center", marginTop: "80px" }}>
      <h1>404 - Not Found</h1>
      <p>The page you are looking for does not exist.</p>
      <p>Redirecting to All Batches...</p>
    </div>
  );
};

export default PageNotFound;
